var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"invalid-feedback":_vm.errorTxt,"state":_vm.state}},[_c('b-form-checkbox-group',{attrs:{"state":_vm.state,"options":_vm.options},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }